export default {"src":"/_next/static/media/atom.259fd4f9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};